export var LoyaltyAccountStatus = {
  Active: "active",
  Paused: "paused"
};